import { useIntl } from "react-intl";
import StatusBadge from "../status-badge";

//<editor-fold desc="Props">
export interface RoleTypeBadgeProps {
  type: "orgadmin" | "role" | string | undefined;
  withLabel?: boolean;
}
//</editor-fold>

function RoleTypeBadge(props: RoleTypeBadgeProps) {
  //<editor-fold desc="Local variables">
  const intl = useIntl();
  let { type, withLabel } = props;
  const d: any = {};
  if (type === "orgadmin") {
    d.label = intl.formatMessage({
      defaultMessage: "Admin",
      description: "Label for the designated admin role type.",
    });
    d.tip = intl.formatMessage(
      {
        defaultMessage:
          "{value}: Designated organization admin role. Inherits permissions set at system level.",
        description:
          "tooltip content for role type admin. value=role type label",
      },
      {
        value: <strong key={"value"}>{d.label}</strong>,
      }
    );
    d.badgeStyle = "badge-primary";
  } else if (type === "role") {
    d.label = intl.formatMessage({
      defaultMessage: "Custom",
      description: "Type label for a custom role.",
    });
    d.tip = intl.formatMessage(
      {
        defaultMessage: "{value}: A custom role.",
        description:
          "tooltip content for role type custom. value=role type label",
      },
      {
        value: <strong key={"value"}>{d.label}</strong>,
      }
    );
    d.badgeStyle = "badge-secondary";
  }
  return <StatusBadge item={d} withLabel={withLabel} />;
}
export default RoleTypeBadge;
